import { render, staticRenderFns } from "./ClientPopup.vue?vue&type=template&id=587b6e96&scoped=true&"
import script from "./ClientPopup.vue?vue&type=script&lang=js&"
export * from "./ClientPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587b6e96",
  null
  
)

export default component.exports